import depsloader from "../depsloader";

export default () => {
	const elms = document.querySelectorAll(".counter-group__item");
	depsloader.load("countup").then((CountUp) => {
		elms.forEach(elm => {
			const end = elm.getAttribute("data-end");
			const suffix = elm.getAttribute("data-suffix");

			console.log(end, suffix);

			let settings = {
				duration: 2.7,
				useEasing: true,
				useGrouping: true,
				enableScrollSpy: true,
				start: 0,
				suffix: suffix || '',
				separator: '',
			}

			new CountUp(elm, end, settings);
		});
	});
}